// extracted by mini-css-extract-plugin
export var phone = "_33-0";
export var phoneDragging = "_33-1";